// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin__details__wrapper {
  background-color: white;
  box-shadow: 0px 0px 5px 1px #787878;
  border-bottom: 1px solid #f8f8f8;
  padding: 1rem;
}

.admin__details__container {
  display: flex;
}

.admin__details__container p {
  padding: 0 3rem 0 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/AdminManagement/searchTab/SearchDetails/AdminDetails.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".admin__details__wrapper {\n  background-color: white;\n  box-shadow: 0px 0px 5px 1px #787878;\n  border-bottom: 1px solid #f8f8f8;\n  padding: 1rem;\n}\n\n.admin__details__container {\n  display: flex;\n}\n\n.admin__details__container p {\n  padding: 0 3rem 0 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
